import {adopt} from 'react-adopt';
import {makeMutation} from '../../util/ContainerUtils';
import {AddPayment, GetCustomer} from './query.graphql';

export const CustomerMutations = adopt( {
    addPayment: makeMutation( {
        mutation: AddPayment,
        update: addPaymentUpdateStrategy
    } )

} );

/**
 * **********************
 * Note -> Update Strategies
 * **********************
 */
export function addPaymentUpdateStrategy ( store, {data: {addPayment}} ) {
    const data = store.readQuery( {
        query: GetCustomer,
        variables: {withWallet: true}
    } );

    // data.customer.wallet = addPayment.wallet;
    if ( data.customer.wallet ) {
        data.customer.wallet.creditCards = data.customer.wallet.creditCards || [];
        data.customer.wallet.creditCards.push( addPayment.addedPayment );
    }

    store.writeQuery( {
        query: GetCustomer,
        variables: {withWallet: true},
        data
    } );
}


/**
 * **********************
 * Note -> Apollo mutation input helpers
 * **********************
 */
export function toPaymentInput ( data ) {
    const {
        cardholder,
        cardType,
        expiresMonth,
        expiresYear,
        securityCode,
        billingAddress,
        billingAddressId,
        accessToken
    } = data;
    return {
        accessToken,
        cardholder,
        cardType,
        securityCode,
        billingAddress,
        billingAddressId: billingAddressId && parseInt( billingAddressId, 10 ),
        expirationDate: expiresMonth + '/' + expiresYear
    };

}

export function toAddressInput ( data ) {
    const {address1, address2, city, state, postalCode} = data;
    return {
        address1,
        address2,
        city,
        state,
        postalCode: String( postalCode )
    };
}

export function toProductOfferingLocationsInput ( data ) {
    return {
        productOfferingLocations: data.map( toProductOfferingLocationInput )
    }
}

export function toProductOfferingLocationInput ( data ) {
    const {address, ...rest} = data;
    return {
        addressId: address.id,
        ...rest
    };
}


